module.exports = __webpack_public_path__ + "img/tour-close.b56155fa.svg";